import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationSharedService } from '../registration-shared.service';

@Injectable({
  providedIn: 'root',
})
export class StepEstablishmentGuard  {
  private registrationSharedService = inject(RegistrationSharedService);
  private router = inject(Router);
  
  constructor() {}

  canActivate(): boolean {
    if (this.registrationSharedService.registrationData.customer.email) {
      return true;
    }

    document.location.href = '/';
    return false;
  }
}
